import { request } from '@/apis/request';
import httpApi from '@/apis/httpApi';
import { gameListData } from '../typings';
import { RankGamesData, Record as RankGameRecord, Type } from './rankData';
import { normalizeRankCode } from '../config/rankCode';

export interface listJson {
  id: string | number;
  version_name: string;
  checked: number;
  rank: number;
  tag_id: string | number;
  tag_name: string;
}

export interface versionTagJson {
  tagList: listJson[];
  versionList: listJson[];
}

// 版本与标签接口
export function getTagVersionList() {
  return request<versionTagJson>({
    method: 'POST',
    url: httpApi.home.tagList
  });
}

interface getAllLabelParams {
  gameType: number;
}

export interface allLabelJson {
  groupId?: number;
  groupName: string;
  groupRank?: number;
  labelTitle: string;
  labelId: number;
  labelName: string;
  checked?: number;
  rank: number;
}

export function getAllLabel(params: getAllLabelParams) {
  return request<allLabelJson[]>({
    method: 'GET',
    url: httpApi.home.getAllLabel,
    params
  });
}
// 获取榜单配置 -- java
interface RankConfigListParams {
  gameType: string | number;
}
export interface CandidateConfig {
  code: string;
  name: string;
  whetherDel?: boolean; // 是否可以删除
}
export interface RankConfigListJson {
  /*
   * 待选榜单
   */
  candidateConfig: CandidateConfig[];
  /**
   * 用户当前榜单配置
   */
  currentConfig: CandidateConfig[];
}
export function apiRankConfigList(params: RankConfigListParams) {
  return request<RankConfigListJson>({
    method: 'GET',
    url: httpApi.home.rankConfigList,
    params
  });
}

// 保存榜单配置
export interface RankConfigSaveParams {
  gameType: string | number;
  selectedCodes: string[]; // 数组中 榜单code请保持顺序传递
}
export function apiRankConfigSave(data: RankConfigSaveParams) {
  return request({
    method: 'POST',
    url: httpApi.home.rankConfigSave,
    data
  });
}

// 保存榜单配置
export interface RankGamesParams {
  /**
   * 定位信息，上页的服务端返回的data.nextCursor，需原样返回。每第一页不传值
   */
  cursor?: string;
  /**
   * 游戏类型，默认：传奇
   */
  gameType: string | number;
  /**
   * 游戏标签ID集
   */
  labelIds?: number[] | string;
  /**
   * 分页大小
   */
  pageSize: number;
  /**
   * 榜单码
   */
  rankCode: string;
}
// 排行榜接口 - java - 宋劲松
export function apiRankGames(data: RankGamesParams) {
  return request<RankGamesData>({
    method: 'POST',
    url: httpApi.home.rankGames,
    data
  });
}

export interface RankGameListParams {
  size: number;
  gameType: number;
  type: number | string;
  labelId?: string | number;
  cursor?: string;
}

export interface RankGameListData {
  list: gameListData[];
  total?: number;
  hasMore: boolean;
  nextCursor?: string;
}

const toNumberValue = (value?: string | number | null) => {
  if (value === undefined || value === null || value === '') return undefined;
  const result = Number(value);
  return Number.isNaN(result) ? undefined : result;
};

const toLabelIds = (value?: string | number | null): number[] | undefined => {
  if (value === undefined || value === null || value === '') return undefined;

  const ids = String(value)
    .split(',')
    .map(item => Number(item.trim()))
    .filter(id => !Number.isNaN(id));

  return ids.length ? ids : undefined;
};

const toGameListData = (item: RankGameRecord): gameListData => {
  const loadingInfo = item.gameLaunch?.loadingInfo;
  const appId = toNumberValue(loadingInfo?.appId);
  const isAward = item.messageBlock?.type === Type.Award;

  return {
    box_game_id: item.gameId,
    game_name: item.gameName,
    game_rank_logo_url: item.gameRankLogoUrl,
    game_score: String(item.feature?.score ?? item.feature?.gameGqs ?? '0'),
    game_appid: appId,
    recentStartNumber: !isAward ? item.messageBlock?.text || '' : '',
    labelList:
      item.gameLabels?.map(label => ({
        labelName: label.name
      })) || [],
    live_no: item.bizInfo?.isLiving ? 1 : undefined,
    isNewGame: item.isNewGame,
    awardName: isAward ? item.messageBlock?.text || '' : ''
  };
};

export async function getRankGameList(params: RankGameListParams) {
  const labelIds = toLabelIds(params.labelId);
  const res = await apiRankGames({
    cursor: params.cursor || '',
    gameType: params.gameType,
    labelIds,
    pageSize: params.size,
    rankCode: normalizeRankCode(params.type)
  });
  const list = res.data.records.map(toGameListData);
  const data: RankGameListData = {
    list,
    hasMore: res.data.hasMore,
    nextCursor: res.data.nextCursor
  };
  return {
    ...res,
    data
  };
}
